import { render, staticRenderFns } from "./user-groups-tab.vue?vue&type=template&id=535fb2a5&scoped=true&"
import script from "./user-groups-tab.vue?vue&type=script&lang=tsx&"
export * from "./user-groups-tab.vue?vue&type=script&lang=tsx&"
import style0 from "./user-groups-tab.vue?vue&type=style&index=0&id=535fb2a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535fb2a5",
  null
  
)

export default component.exports